import {
    START_LOADING,
    END_LOADING,
    CREATE_USER_GROUP ,
    UPDATE_USER_GROUP ,
    DELETE_USER_GROUP ,
    FETCH_USER_GROUP ,
    FETCH_USER_GROUPS,
    FETCH_ROLES
} from '../actions/constants'

const userGroups = (state = {isLoading: false, userGroups: [],roles:[]}, action) => {
    switch (action.type) {
        case START_LOADING:
            return {...state, isLoading: true};
        case END_LOADING:
            return {...state, isLoading: false};
        case FETCH_USER_GROUPS:
            return {...state, userGroups: action.payload.userGroups, numberOfPages: action.payload.numberOfPages};
        case FETCH_ROLES:
            return {...state, roles: action.payload};
        case FETCH_USER_GROUP:
            return {...state, userGroup: action.payload.userGroup};
        case CREATE_USER_GROUP:
            return {...state, userGroups: [...state.userGroups, action.payload]};
        case UPDATE_USER_GROUP:
            return {
                ...state,
                userGroups: state.userGroups.map((userGroup) => (userGroup._id === action.payload._id ? action.payload : userGroup))
            };
        case DELETE_USER_GROUP:
            return {...state, userGroups: state.userGroups.filter((userGroup) => userGroup._id !== action.payload)};
        default:
            return state;
    }
};

export default userGroups

